import _ from 'underscore';
import { BaseFactory } from './convertor-factory/base-factory';
import { NumberFactory } from './convertor-factory/number-factory';
import { BigIntFactory } from './convertor-factory/bigint-factory';
import { IFieldSchema, IConvertorFactory } from '../types';

function getConvertorFactoryByType(prop: IFieldSchema, i18n: I18nModel): IConvertorFactory {
  switch (prop.type) {
    case 'bigint':
      return new BigIntFactory({ prop, i18n });
    case 'integer':
      return new NumberFactory({ prop: _.defaults({ decimalLength: 0 }, prop), i18n });
    case 'number':
      return new NumberFactory({ prop: _.defaults({ decimalLength: 2 }, prop), i18n });
    default:
      return new BaseFactory({ prop, i18n });
  }
}

/**
 * Create conversion object by field type
 * @param {IFieldSchema} prop - Schema field properties
 * @param {I18nModel} i18n - i18n for localization
 * @returns {unknown} - returns conversion object
 */
export function createConversion(prop: IFieldSchema, i18n: I18nModel): unknown {
  const factory = getConvertorFactoryByType(prop, i18n);

  return factory.create();
}
